import { DialogProps } from "@mui/material";
import { useReducer } from "react";

export type PartialDialog = Partial<DialogProps>;

type DialogReducer = (state: PartialDialog, action: DialogAction) => PartialDialog;

interface DialogAction {
  type: string;
  payload?: PartialDialog;
}

export const dialogInitialState: PartialDialog = {
  open: false,
};

const dialogReducer: DialogReducer = (state: PartialDialog, action: DialogAction): PartialDialog => {
  switch (action.type) {
    case "openDialog":
      return {
        ...state,
        ...action.payload,
        open: true,
      };
    case "closeDialog":
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
};

export default function DialogState() {
  const [dialogProps, dispatchDialogAction] = useReducer(dialogReducer, dialogInitialState);

  const handleDisplayDialog = (dialog: PartialDialog) => {
    dispatchDialogAction({ type: "openDialog", payload: dialog });
  };

  const handleClearDialog = () => {
    dispatchDialogAction({ type: "closeDialog" });
  };

  return {
    dialogProps,
    handleDisplayDialog,
    handleClearDialog,
  } as const;
}
